<template>
  <div class="ban">
    <van-nav-bar title="禁用农药清单" style="z-index:2" left-arrow fixed @click-left="onClickLeft" />
    <div class="main">
      <wh-mobile-list ref="listTable" height="100%" :get-list-data="getListData" data-src="https://sit.whhda.xyz/traceTools/inputBannedPesticide/find">
        <template v-slot="{list}">
          <van-collapse v-model="activeName" accordion>
            <van-collapse-item v-for="i in list" :key="i.id" :title="i.name" :name="i.id">
              {{ i.info }}
            </van-collapse-item>
          </van-collapse>
        </template>
      </wh-mobile-list>
    </div>
  </div>
</template>
<script>
import WhMobileList from '@/components/public/WhMobileList/WhMobileList'
export default {
  components: { WhMobileList },
  data() {
    return {
      activeName: ''
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    getListData(res) {
      return res.data.items
    }
  }
}
</script>
<style lang="less" scoped>
.ban{
   height: 100vh;
  .main{
    height: 100%;
  }
}

</style>
